import { runInAction } from 'mobx';
import { installAuthRefreshInterceptor } from '@partsbadger/utils';

import UserStore from '../stores/UserStore';

export function installCustomerAuthRefresh() {
    return installAuthRefreshInterceptor({
        onTokenRefreshed: token =>
            runInAction(() => {
                UserStore.token = token;
            }),
        onSessionExpired: () => UserStore.removeTokens(),
    });
}
